module.exports = __webpack_public_path__ + "static/media/img9.5b59e8e3.png";